module.exports = __webpack_public_path__ + "static/media/google.656a6db3.png";